// import React, {useState} from 'react';
import React, { Component } from 'react';
import { uploadFile } from 'react-s3';
import { If, Then, Else  } from 'react-if';
import { Facebook } from 'react-spinners-css';
import axios from 'axios';
import '../style/profile.css';
window.Buffer = window.Buffer || require("buffer").Buffer;

const ACCESS_KEY=process.env.REACT_APP_AWS_KEY;
const SECRET_ACCESS_KEY=process.env.REACT_APP_SECRET;
const S3_BUCKET=process.env.REACT_APP_BUCKET;
const REGION=process.env.REACT_APP_REGION;

const config = {
    bucketName: S3_BUCKET,
    region: REGION,
    accessKeyId: ACCESS_KEY,
    secretAccessKey: SECRET_ACCESS_KEY,
}

const server = process.env.REACT_APP_SERVER;

class UploadImageToS3WithReactS3 extends Component {
    constructor(props){
        super(props);
        this.state = {
            selectedFile: null,
            userImages: [],
            currentUpload: '',
            isUploading: false
        }
    }
    
    handleFileInput = (e) => {
        this.setState({selectedFile: e.target.files[0]});
    }
    
    handleUpload = async (file) => {
        this.setState({isUploading: true});
        uploadFile(file, config)
        .then(data => {
            const axiosConfig = {
                headers: { Authorization: `Bearer ${this.props.token}` }
            };
            axios.post(`${server}/meme`, {uploaderId: this.props.userId, username: this.props.username, imageUrl: data.location}, axiosConfig)
            .then((response) => {
                this.props.addMeme(response.data);
                this.setState({isUploading: false});
                alert("successfully uploaded");
            }).catch((error) => {
                console.error(error.message);
            });
        })
        .catch(err => console.error(err))
    }

    render() {
        return (
            <>
                <If condition={this.state.isUploading}>
                <Then>
                    <div id='upload-title' className='upload-spacing'>Sick meme, posse! This may take a moment...</div>
                    <div className='loading'>
                        <Facebook color="#66FCF1" />
                    </div> 
                </Then>
                <Else>
                <div id='upload-title' className='upload-spacing'>Upload Meme</div>
                    <input type="file" onChange={this.handleFileInput} className='custom-file-input'/>
                    <button onClick={() => this.handleUpload(this.state.selectedFile)} id="form-button" className="btn btn-primary btn-block">Upload</button>             
                </Else>
                </If>
            </>
        )
    }
}

export default UploadImageToS3WithReactS3;